import {
    ChangeDetectionStrategy,
    Component,
    input,
    OnInit,
    output,
    signal,
    viewChild,
} from '@angular/core'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { TbDividerComponent } from '@components-library/tb-divider/tb-divider.component'
import { TbDragHandlerDirective } from '@components-library/tb-drag-and-drop/tb-drag-handler.directive'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TbInputComponent } from '@components-library/tb-input/tb-input.component'
import { TbMenuComponent } from '@components-library/tb-menu'
import { TbMenuListItemComponent } from '@components-library/tb-menu-list-item/tb-menu-list-item.component'
import { TbMenuListComponent } from '@components-library/tb-menu-list/tb-menu-list.component'
import { SelectOption } from '@models/response/select-object-options'
import { Field } from '@models/ui'
import { TranslocoModule } from '@jsverse/transloco'
import { ColorPickerComponent } from '@shared/color-picker/color-picker.component'
import { IconPickerComponent, PickerIcon } from '@shared/icon-picker/icon-picker.component'
import { SetType } from '@shared/models/picker'
import { ModalLayoutComponent } from '@components-library/tb-modal-manager/modal-layout/modal-layout.component'
import { ModalContainerTypes } from '@components-library/tb-modal-manager/modal-manager.service'
import { OptionControl } from '@app/feature/add-field/add-field-content/select-settings/select-settings-form.service'

@Component({
    selector: 'app-select-option',
    imports: [
        TbDragHandlerDirective,
        TbIconComponent,
        ColorPickerComponent,
        MatFormFieldModule,
        TbMenuComponent,
        TbMenuListComponent,
        TbMenuListItemComponent,
        TbDividerComponent,
        TranslocoModule,
        IconPickerComponent,
        TbInputComponent,
        ReactiveFormsModule,
        ModalLayoutComponent,
    ],
    templateUrl: './select-option.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectOptionComponent implements OnInit {
    protected readonly SetType = SetType
    protected readonly ModalContainer = ModalContainerTypes

    option = input.required<SelectOption>()
    optionGroup = input.required<FormGroup<OptionControl>>()
    field = input.required<Field>()
    dragDisabled = input(false)

    isDefault = input(false)
    template = input(false)

    delete = output()
    defaultChange = output()

    iconPicker = viewChild<IconPickerComponent>('iconPicker')

    isClosed = signal(false)

    constructor() {}

    ngOnInit(): void {
        this.isClosed.set(this.option().tags === 'close')
    }

    updateIcon(iconObject: PickerIcon) {
        if (iconObject.icon === 'add_reaction') {
            return
        }

        this.optionGroup().controls.icon.setValue(iconObject.icon ?? '')
    }
}
